import React, { PureComponent } from "react";
import styled from "styled-components";

export interface Props {
  websiteUrl: string;
  podcastTitle: string;
  episodes: any;
  customColors: any;
  hidePodcastTitle: any;
  hideEpisodeTitle: any;
  episodeTitle?: any;
  isCustomPlaylist?: boolean;
  programIndex?: number;
  playlistIndex?: any;
}
/**
 * AudioWidget player composition - Renders all the audioplayer's components.
 */
export default class PlayerHeadings extends PureComponent<Props, any> {
  constructor(props: Props) {
    super(props);
    this.state = {
      itemsHidden:
        this.props.hideEpisodeTitle === "true" ||
        this.props.hidePodcastTitle === "true"
          ? true
          : false,
      hasCustomColors: this.props.customColors.length > 0 ? true : false
    };
  }

  componentDidUpdate() {}

  render() {
    const isPodcast = this.state.playerType === "podcast";
    const customColors = this.state.hasCustomColors
      ? this.props.customColors
      : [];

    const episodeUrl = this.state.itemsHidden
      ? "#"
      : this.props.episodes[this.props.programIndex].link;
    const podcastUrl = this.state.itemsHidden ? "#" : this.props.websiteUrl;

    let titles;

    if (this.props.isCustomPlaylist) {
      titles = {
        titleTop: this.props.episodeTitle,
        titleBottom: this.props.episodes[this.props.playlistIndex].title
      };
      this.props.podcastTitle;
    } else if (!this.props.isCustomPlaylist) {
      titles = {
        titleTop: isPodcast
          ? this.props.episodes[this.props.programIndex].title
          : this.props.podcastTitle,
        titleBottom: isPodcast
          ? this.props.podcastTitle
          : this.props.episodes[this.props.programIndex].title
      };
    }
    const headingTop = (
      <a
        href={isPodcast ? episodeUrl : podcastUrl}
        target={this.state.itemsHidden ? "" : "_blank"}
        className={isPodcast ? "episode-title" : "show-title"}
      >
        <H1 customColors={customColors} itemsHidden={this.state.itemsHidden}>
          {titles.titleTop}
        </H1>
      </a>
    );

    const headingBottom = (
      <a
        href={isPodcast ? podcastUrl : episodeUrl}
        target={this.state.itemsHidden ? "" : "_blank"}
        className={isPodcast ? "show-title" : "episode-title"}
      >
        <H2 customColors={customColors} itemsHidden={this.state.itemsHidden}>
          {titles.titleBottom}
        </H2>
      </a>
    );

    if (isPodcast) {
      return (
        <div>
          {this.props.hideEpisodeTitle === "true" ? "" : headingTop}
          {this.props.hidePodcastTitle === "true" ? "" : headingBottom}
        </div>
      );
    } else {
      return (
        <div>
          {this.props.hidePodcastTitle === "true" ? "" : headingTop}
          {this.props.hideEpisodeTitle === "true" ? "" : headingBottom}
        </div>
      );
    }
  }
}

const H1: any = styled.h1`
  line-height: ${(props: any) => (props.itemsHidden ? "1.4" : "14px")};
  font-size: ${(props: any) => (props.itemsHidden ? "14px" : "12px")};
  color: ${(props: any) =>
    props.customColors.length > 0 ? props.customColors[1] : "#fff"};
  margin: 0;
  margin-right: 10px;
  &:hover {
    color: ${(props: any) =>
      props.itemsHidden
        ? props.customColors.length > 0
          ? props.customColors[1]
          : "#fff"
        : props.customColors.length > 0
        ? props.customColors[0]
        : "#ffcb2e"};
  }
`;

const H2: any = styled.h2`
  margin-top: 0;
  font-size: ${(props: any) => (props.itemsHidden ? "14px" : "12px")};
  line-height: ${(props: any) => (props.itemsHidden ? "1.4" : "14px")};
  color: ${(props: any) =>
    props.customColors.length > 0 ? props.customColors[1] : "#fff"};
  margin-bottom: 0px;
  &:hover {
    color: ${(props: any) =>
      props.itemsHidden
        ? props.customColors.length > 0
          ? props.customColors[1]
          : "#fff"
        : props.customColors.length > 0
        ? props.customColors[0]
        : "rgba(255,255,255,0.4)"};
  }
`;
